<template lang="html">
  <div class="commentProductList">
    <commentProductItem
      v-for="comment in items"
      :comment="comment"
      :key="comment.id"
    ></commentProductItem>
  </div>
</template>

<script>
import commentProductItem from './commentProductItem'

export default {
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    commentProductItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.commentProductList {
  min-height: 100%;
  padding: 0 rem(36px);
  background-color: #fff;
  overflow-x: hidden;
  border-radius: rem(20px) rem(20px) 0 0;
}
</style>
